import http from 'utils/request'
import type { ResponseModel, ServeConfigModel } from './base-model'

export function getConfig() {
  return http.Get<ResponseModel<ServeConfigModel>>('/getConfig', { meta: { authRole: null } })
}
